import {
  useInfiniteQuery,
  UseInfiniteQueryOptions,
  useMutation,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import { MonitoringWebsiteEnforcedTp } from '~/swagger/MonitoringWebsiteEnforcedTp';
import {
  MonitoringWebsiteSwEnforcedTpProtocolsExportExcelRequest,
  MonitoringWebsiteSwEnforcedTpProtocolsGetAllWebsiteIdsRequest,
  MonitoringWebsiteSwEnforcedTpProtocolsGetAllWebsiteIdsResponse,
  MonitoringWebsiteSwEnforcedTpProtocolsGetCountAndRecentlyListingRequest,
  MonitoringWebsiteSwEnforcedTpProtocolsGetCountAndRecentlyListingResponse,
  MonitoringWebsiteSwEnforcedTpProtocolsGetDetailsRequest,
  MonitoringWebsiteSwEnforcedTpProtocolsGetDetailsResponse,
  MonitoringWebsiteSwEnforcedTpProtocolsGetWebsitesRequest,
  MonitoringWebsiteSwEnforcedTpProtocolsGetWebsitesResponse,
} from '~/swagger/data-contracts';
import { http } from '../../base';

const monitoringWebsiteEnforcedTpApi = new MonitoringWebsiteEnforcedTp(http);

export const QueryKeyPrefix = ['enforcement', 'website', 'tp'];

// website > tp: reviewing, purchased, completed, case closed 상태별 개수 조회
export const useEnforcementWebSiteTpCountQuery = (
  request: MonitoringWebsiteSwEnforcedTpProtocolsGetCountAndRecentlyListingRequest,
  options?: UseQueryOptions<MonitoringWebsiteSwEnforcedTpProtocolsGetCountAndRecentlyListingResponse>
) => {
  return useQuery({
    queryKey: [...QueryKeyPrefix, 'count', request],
    queryFn: async () => {
      const { data } = await monitoringWebsiteEnforcedTpApi.enforcementWebSiteTpCountCreate(request);
      return data;
    },
    ...options,
  });
};
export const useEnforcementWebSiteTpWebSiteListQuery = (
  request: MonitoringWebsiteSwEnforcedTpProtocolsGetWebsitesRequest,
  options?: UseInfiniteQueryOptions<MonitoringWebsiteSwEnforcedTpProtocolsGetWebsitesResponse>
) => {
  return useInfiniteQuery<MonitoringWebsiteSwEnforcedTpProtocolsGetWebsitesResponse>({
    queryKey: [...QueryKeyPrefix, 'list', request],
    queryFn: async ({ pageParam }) => {
      const { data } = await monitoringWebsiteEnforcedTpApi.enforcementWebSiteTpWebSitesCreate({
        ...request,
        offset: pageParam || request.offset,
      });

      return data;
    },
    ...options,
    getNextPageParam: (lastPage, allPage) => {
      if (lastPage.website_list.length < 50) {
        return;
      }

      return request.limit ? request.limit * allPage.length : 0;
    },
  });
};
export const useEnforcementWebSiteTpWebSiteTableViewListQuery = (
  request: MonitoringWebsiteSwEnforcedTpProtocolsGetWebsitesRequest,
  options?: UseQueryOptions<MonitoringWebsiteSwEnforcedTpProtocolsGetWebsitesResponse>
) => {
  return useQuery<MonitoringWebsiteSwEnforcedTpProtocolsGetWebsitesResponse>({
    queryKey: [...QueryKeyPrefix, 'table-list', request],
    queryFn: async () => {
      const { data } = await monitoringWebsiteEnforcedTpApi.enforcementWebSiteTpWebSitesCreate(request);

      return data;
    },
    ...options,
  });
};
export const useEnforcementWebSiteTpAllWebSiteIdsQuery = (
  request: MonitoringWebsiteSwEnforcedTpProtocolsGetAllWebsiteIdsRequest,
  options?: UseQueryOptions<MonitoringWebsiteSwEnforcedTpProtocolsGetAllWebsiteIdsResponse>
) => {
  return useQuery({
    queryKey: [...QueryKeyPrefix, 'all-listing-ids'],
    queryFn: async () => {
      const { data } = await monitoringWebsiteEnforcedTpApi.enforcementWebSiteTpAllWebSiteIdsCreate(request);
      return data;
    },
    ...options,
  });
};

/**
 * enforcement > website > tp: 전체 리스트 excel export 요청
 */
export const useEnforcementWebSiteTpExcelMutation = () => {
  return useMutation({
    mutationFn: async (request: MonitoringWebsiteSwEnforcedTpProtocolsExportExcelRequest) => {
      const { data } = await monitoringWebsiteEnforcedTpApi.enforcementWebSiteTpExcelCreate(request);
      return data;
    },
  });
};

//detail panel
export const useEnforcementWebSiteTpDetailPanelQuery = (
  request: MonitoringWebsiteSwEnforcedTpProtocolsGetDetailsRequest,
  options?: UseQueryOptions<MonitoringWebsiteSwEnforcedTpProtocolsGetDetailsResponse>
) => {
  return useQuery({
    queryKey: [...QueryKeyPrefix, 'detail', request],
    queryFn: async () => {
      const { data } = await monitoringWebsiteEnforcedTpApi.enforcementWebSiteTpDetailsCreate(request);
      return data;
    },
    ...options,
  });
};
